export const dataHooks = {
  datePickerCalendar: 'date-picker-calendar',
  datePickerPopover: 'date-picker-popover',
  datePickerInputContainer: 'date-picker-input-container',
  datePickerInput: 'date-picker-input',
};

export const MAX_DATE = new Date(2201, 0, 1);
export const MIN_DATE = new Date(1000, 0, 1);
export const SHORT_SEPARATORS_REGEX = new RegExp(
  /^\w+(?:\s*(\.|-| |\/)\s*\w+){1,2}$/,
);
